import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getCustomerFilesFullSummariesRequest } from '../../api/Workflow/files/getCustomerFilesFullSummariesQuery';

import * as ActionTypes from './actionTypes';

function* loadCustomerFilesSummaryWorker({ payload: fileIds }) {
  const filteredFileIds = fileIds.filter((id) => !!id);

  if (filteredFileIds.length) {
    yield executeSagaRequest(
      ActionTypes.LOAD_CUSTOMER_FILES_SUMMARY,
      getCustomerFilesFullSummariesRequest({ fileIds: filteredFileIds }),
    );
  }
  yield put(ActionTypes.LOAD_CUSTOMER_FILES_SUMMARY.end());
}
export function* loadCustomerFilesSummaryWatcher() {
  yield takeEvery(
    ActionTypes.LOAD_CUSTOMER_FILES_SUMMARY.BASE,
    loadCustomerFilesSummaryWorker,
  );
}

export default function* fileSaga() {
  try {
    yield all([loadCustomerFilesSummaryWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
